// for extracting from react router - use getPatientIdFromRoute
export const getPatientIdFromRoute = (params: { patientId: string }) => {
  const { patientId } = params;
  return parseInt(patientId, 10);
};
